import React from 'react';
import { Exercise } from '../../../../../models/Exercise';
import { Ticket } from '../../../../../models/Ticket';
import EAInfoTile from '../../../../shared/InfoTile/EAInfoTile';
import useDesktopSize from '../../../../../../utils/hooks/useDesktopSize';
import { useTranslation } from 'react-i18next';
import { IoImage } from 'react-icons/io5';
import { SRLWrapper } from "simple-react-lightbox";

interface IProps {
  exercise: Exercise;
  ticket: Ticket;
}

const ReservationModalHeader: React.FC<IProps> = ({ exercise, ticket }) => {
  const isDesktop = useDesktopSize();
  const { t } = useTranslation();

  // Calculate time remaining
  const getTimeRemaining = (): string => {
    const now = new Date();
    const exerciseStart = new Date(exercise.startTime);
    const diffMs = exerciseStart.getTime() - now.getTime();

    if (diffMs <= 0) return t("minelo");

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays > 0) {
      return `za ${diffDays} ${diffDays === 1 ? "dzień" : "dni"}`;
    }

    return `za ${diffHours} ${diffHours === 1 ? "godzinę" : "godzin"}`;
  };

  const isEventPassed = new Date(exercise.startTime) <= new Date();

  return (
    <div className="reservation-modal__header">
      {isDesktop && (
        <div
          className={`reservation-modal__header-tile ${isEventPassed ? "reservation-modal__header-tile--past" : ""}`}
        >
          <EAInfoTile date={new Date(exercise.startTime)} size="medium" color={isEventPassed ? "gray" : "primary"} />
        </div>
      )}

      <div className="reservation-modal__header-content">
        <h5 className="reservation-modal__title">{exercise.name}</h5>
        <span className={`body-text-small ${isEventPassed ? "text-color-light-gray" : "text-color-dark-gray"}`}>
          {getTimeRemaining()}
        </span>
      </div>

      {exercise.eventMessage ? (
        <SRLWrapper
          options={{
            settings: {
              autoplaySpeed: 0,
              disableKeyboardControls: false,
              disablePanzoom: false,
              hideControlsAfter: false,
            },
            buttons: {
              showAutoplayButton: false,
              showDownloadButton: false,
              showFullscreenButton: true,
              showNextButton: false,
              showPrevButton: false,
              showThumbnailsButton: false,
            },
            caption: {
              showCaption: false,
            },
          }}
        >
          <div className="reservation-modal__header-image reservation-modal__header-image--clickable">
            <img src={exercise.eventMessage} alt={exercise.name} />
          </div>
        </SRLWrapper>
      ) : (
        <div className="reservation-modal__header-image reservation-modal__header-image--placeholder">
          <IoImage />
        </div>
      )}
    </div>
  );
};

export default ReservationModalHeader;
